<template>
  <section class="task-wrap" :style="dBHeight">
    <div class="tab_ty1">
      <AuditTab :currentTab="2" />
      <div class="tab-content">
        <!-- 이력 Tab -->
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="2" :currentTab2="1" />
            <div class="tab-content">
              <div>
                <div class="tb-list_ty1 audit001">
                  <div class="tb-header clear">
                    <SelectBox
                        v-model="selectedDeptId"
                        valueProp = "deptId"
                        textProp = "deptName"
                        :disabled="view.disabled"
                        :excludes="view.selectExcludes"
                        div-cls="selectDiv"
                        :dtl-cd-list="depts.selectList"
                        v-if="deptList > 0 && roleIdCount == 1"
                        style="float: left; margin-top: 6px; margin-right: 20px;">
                    </SelectBox>
                    <div class="tb_num fl">
                      <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건',{cnt:totalCount})">
                      </div>
                    </div>
                    <div class="search_ty2 fr">
                      <div class="calendar_box_grp small">
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="startDate"
                            :disabled-dates="startDisabledDate"
                          ></datepicker>
                        </div>
                        <span>~</span>
                        <div class="calendar_box">
                          <datepicker
                            format="yyyy.MM.dd"
                            v-model="endDate"
                            :disabled-dates="endDisabledDate"
                          ></datepicker>
                        </div>
                      </div>
                      <div class="search_ty2">
                        <input
                          type="text"
                          required
                          :placeholder="$i18nUtil.trans('message.FileCopyList.001','사용자명/사용자ID 검색')"
                          @focus="$event.target.placeholder = ''"
                          @focusout="
                            $event.target.placeholder =$i18nUtil.trans('message.FileCopyList.001','사용자명/사용자ID 검색')
                          "
                          v-model="searchUser"
                          @keyup.enter="getFileDownloadList()"
                        />
                        <button
                          type="button"
                          class="input-txt"
                          @click="getFileDownloadList()"
                        >
                          {{$i18nUtil.trans("search.039","검색")}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- //tb-header -->

                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="fileDownloadList"
                    hide-default-footer
                    class="tb-contents"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <div>
                            <span
                              class="cursor-pointer" 
                              @click="insertBoardViewAuthFDLG(item.locationId, item.fileId)"
                            >{{ item.fileName }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.fileType }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.locationKubun }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <!-- <span>{{ item.inoutKubun }}</span> -->
                          </div>
                        </td>
                        <td>
                          <div>
                            {{
                              $moment(item.downDate).format("YYYY.MM.DD HH:mm")
                            }}
                          </div>
                        </td>
                        <td>
                          <div>
                            <span
                              >{{ item.downUserName }}({{
                                item.downUserId
                              }})</span
                            >
                          </div>
                        </td>
                      </tr>
                    </template>

                    <template slot="no-data">
                      <div class="nodata-txt-noicon">
                        <v-alert :value="true">
                          {{$i18nUtil.trans("message.FileDownloadList.001","파일다운로드이력이 없습니다.")}}
                        </v-alert>
                      </div>
                    </template>
                  </v-data-table>

                  <div v-show="pageCount > 0" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getFileDownloadList"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import Datepicker from "vuejs-datepicker";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import SelectBox from "./common/SelectBox";

export default {
  components: {
    Datepicker,
    AuditSubTab,
    AuditTab,
    SelectBox,
  },
  data() {
    return {
      selectedDeptId : "",
      view : {
          selectExcludes : [],
          disabled : false
      },
      depts : {
          selectList : []
      },
      deptList : 0,
      roleIdCount : 0,
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      enabled: true,
      show: false,
      page: 1,
      pageCount: 0,
      totalCount: 0,
      itemsPerPage: 10,
      singleSelect: false,
      selected: [],
      headers: [
        { text: this.$i18nUtil.trans("entity.file.fileName","파일명"), value: "fileName", align: "center", sortable: false },
        { text: this.$i18nUtil.trans("entity.file.fileType","파일타입"), value: "fileType", sortable: false },
        { text: this.$i18nUtil.trans("entity.file.locationKbn","파일위치"), value: "locationKubun", sortable: false },
        // { text: "내외부구분", value: "inoutKubun", sortable: false },
        { text: "", sortable: false },
        { text: this.$i18nUtil.trans("entity.file.downDate","다운로드일시"), value: "downDate", sortable: false },
        { text: this.$i18nUtil.trans("entity.file.downUserId","다운로드사용자"), value: "downUserId", sortable: false },
      ],
      fileDownloadList: [],
      searchUser: "",
      startDate: new Date(this.$moment().subtract(1, "months")),
      endDate: new Date(this.$moment()),
      startDisabledDate: {
        from: new Date(this.$moment()),
      },
      endDisabledDate: {
        to: new Date(this.$moment().subtract(1, "months")),
      },
      groupId: "",
    };
  },
  created() {
    this.getDeptList();
    // this.getFileDownloadList();
  },
  watch: {
    startDate() {
      this.page = 1;
      this.getFileDownloadList();
    },
    endDate() {
      this.page = 1;
      this.getFileDownloadList();
    },
    selectedDeptId() {
      this.page = 1;
      this.getFileDownloadList();
    },
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 부서 리스트 조회 */
    getDeptList() {
      let obj = this;
      let reqData = {
        url : "/api/copaper/todo/getOrgDeptUserList",
        method : "post",
        params : {}
      };
      //프로그레스바 시작
      obj.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
            //프로그레스바 종료
            obj.hideLoadingbar();
            if(res.errorCode != null) {
              console.log(res.errorCode);
            }
            else {
              let deptName = '';
              let deptId = '';
              if(res.result.length > 1) {
                for(let i in res.result) {
                  if(i == 0) {
                      deptName = res.result[i].slice(0, res.result[i].indexOf(":"));
                      deptId = res.result[i].substring(res.result[i].indexOf(":")+1);
                      obj.depts.selectList.unshift({"deptName":deptName,"deptId":deptId});
                      obj.selectedDeptId = deptId;
                  } else {
                      deptName = res.result[i].slice(0, res.result[i].indexOf(":"));
                      deptId = res.result[i].substring(res.result[i].indexOf(":")+1);
                      obj.depts.selectList.push({"deptName":deptName,"deptId":deptId});
                  }
                }
                obj.deptList = res.result.length;
              }
              obj.getFileDownloadList();
            }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 파일다운로드이력 목록 조회 */
    getFileDownloadList() {
      let obj = this;

      let reqData = {};
      reqData.params = {
        currentPage: obj.page,
        itemsPerPage: obj.itemsPerPage,
        startDate: obj.$moment(this.startDate).format("YYYYMMDD"),
        endDate: obj.$moment(this.endDate).format("YYYYMMDD"),
        searchUser: obj.searchUser,
        selectedDeptId: obj.selectedDeptId,
      };
      reqData.url = "/api/logging/audit/getFileDownloadList";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.fileDownloadList = res.result.fileDownloadList;
            obj.totalCount = res.result.fileDownloadCount;
            obj.pageCount = res.result.fileDownloadPageCount;
            obj.roleIdCount = res.result.roleIdCount; // 권한 개수
          }
          this.setDisabledDate();
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    setDisabledDate() {
      this.startDisabledDate.from = this.endDate;
      this.endDisabledDate.to = this.startDate;
    },
    insertBoardViewAuthFDLG(locationId, fileId){
      let obj = this;

      let reqData = {};
      reqData.params = {
        paperId: locationId,
      };
      reqData.url = "/api/copaper/paper/insertBoardViewAuthFDLG";
      reqData.method = "post";

      //프로그레스바 시작
      obj.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          obj.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else if(res.result) {
            obj.getFileGroupId(fileId);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    getFileGroupId(fileId){
      let obj = this;

      let reqData = {};
      reqData.params = {
        fileId: fileId,
      };
      reqData.url = "/api/cofile/cofile/getFileGroupId";
      reqData.method = "post";

      //프로그레스바 시작
      obj.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          obj.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          } else {
            obj.groupId = res.result;
            obj.openFileViewer(fileId);
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    /* 파일 뷰어 */
    openFileViewer(fileId) {
      let hanwha = $(location).attr("origin");
      let groupId = this.groupId;
      if (groupId != null || groupId != "") {
        window.open(
          hanwha + "/general/viewer/" + groupId + "/" + fileId
        );
      }
    },
  },
};
</script>

<style scoped>
.audit001 {
  margin-top: 38px;
}
.audit001 >>> th:nth-child(1),
.audit001 >>> td:nth-child(1) {
  padding-left: 25px;
  width: calc(100% - 100px - 100px - 100px - 150px - 250px) !important;
  text-align: left;
}
.audit001 >>> th:nth-child(2),
.audit001 >>> td:nth-child(2) {
  width: 100px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(3),
.audit001 >>> td:nth-child(3) {
  width: 100px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(4),
.audit001 >>> td:nth-child(4) {
  width: 100px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(5),
.audit001 >>> td:nth-child(5) {
  width: 150px !important;
  text-align: center;
}
.audit001 >>> th:nth-child(6),
.audit001 >>> td:nth-child(6) {
  width: 250px !important;
  text-align: center;
}
.audit001 >>> th.text-center {
  text-align: center;
}
.audit001 >>> input {
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/FileDownloadList.vue